<template>
	<div class="additional-tab-form">
		<!-- riepilogo -->
		<v-card outlined class="at-summary mb-4">
			<div class="at-avatar">
				<v-icon color="primary">mdi-tab-plus</v-icon>
			</div>
			<div class="at-main">
				<div class="at-title">{{ nomePrincipale || 'Nuova tab aggiuntiva' }}</div>
				<div class="at-sub">{{ compilate }} di {{ item.trans.length }} lingue compilate · posizione {{ posizione }}</div>
				<div class="at-chips">
					<v-chip v-if="item.is_active === true" x-small label color="success" text-color="white">Attiva</v-chip>
					<v-chip v-else-if="item.is_active === false" x-small label color="grey" text-color="white">Non attiva</v-chip>
					<v-chip v-else x-small label outlined>Stato da scegliere</v-chip>
				</div>
			</div>
		</v-card>

		<v-row class="at-cols">
			<v-col cols="12" md="7">
				<SectionCard title="Nome per lingua" icon="mdi-translate" class="mb-4">
					<div class="pa-2">
						<TestiLinguaTabs :trans="item.trans" campo="name" label="Nome della tab" :traduci="item.trans.length > 1" :errori="errorsTrans" @traduci="$emit('traduci')" />
						<div class="at-hint mt-2">È il titolo della tab nella scheda prodotto del sito, accanto a Descrizione e alle altre.</div>
					</div>
				</SectionCard>
			</v-col>

			<v-col cols="12" md="5">
				<SectionCard title="Impostazioni" icon="mdi-cog-outline" class="mb-4">
					<v-row class="at-fields">
						<v-col cols="12" sm="6" md="12" lg="6">
							<v-select v-model="item.is_active" :items="siNo" item-text="text" item-value="value" label="Attiva" outlined dense hide-details="auto" :error-messages="alerts.is_active"></v-select>
						</v-col>
						<v-col cols="12" sm="6" md="12" lg="6">
							<v-text-field v-model="item.position" type="number" min="0" label="Posizione" outlined dense hide-details="auto" :error-messages="alerts.position"></v-text-field>
						</v-col>
					</v-row>

					<!-- anteprima dell'ordine delle tab con questa evidenziata -->
					<div class="at-order">
						<div class="at-order-label">Ordine delle tab</div>
						<div class="at-order-list">
							<div v-for="(t, i) in ordine" :key="t.chiave" class="at-order-item" :class="{ 'at-order-item--current': t.corrente, 'at-order-item--off': !t.attiva }">
								<span class="at-order-num">{{ i + 1 }}</span>
								<span class="at-order-name">{{ t.nome || '—' }}</span>
								<span class="at-order-pos">pos. {{ t.posizione }}</span>
							</div>
						</div>
						<div class="at-hint mt-1">Le tab si mostrano in ordine di posizione crescente; quelle spente sono in grigio.</div>
					</div>
				</SectionCard>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import _ from 'lodash';
import SectionCard from '@/components/core/SectionCard.vue';
import TestiLinguaTabs from '@/views/setting/components/TestiLinguaTabs.vue';

const SI_NO = [
	{ text: 'Sì', value: true },
	{ text: 'No', value: false },
];

// corpo delle schede Nuova / Modifica tab aggiuntiva: i campi scrivono su `item` come prima
export default {
	name: 'AdditionalTabFormBody',
	components: { SectionCard, TestiLinguaTabs },
	props: {
		item: { type: Object, required: true },
		errorsTrans: { type: Array, default: () => [] },
		alerts: { type: Object, default: () => ({}) },
		// le altre tab gia' salvate (senza quella in modifica)
		altre: { type: Array, default: () => [] },
		// lingua del BO per i nomi delle altre tab
		lang: { type: String, default: 'it' },
		// posto della tab nell'elenco salvato (null = nuova, va in fondo)
		indiceCorrente: { type: Number, default: null },
	},
	data() {
		return { siNo: SI_NO };
	},
	computed: {
		nomePrincipale() {
			return _.get(this.item, 'trans[0].name', '');
		},
		compilate() {
			return this.item.trans.filter(t => t.name).length;
		},
		posizione() {
			return this.item.position === '' || this.item.position === null ? '—' : this.item.position;
		},
		ordine() {
			const nome = t => {
				const tr = _.find(t.trans, { lang: this.lang }) || (t.trans || [])[0];
				return tr ? tr.name : '';
			};
			const lista = this.altre.map(t => ({ chiave: t._id, nome: nome(t), posizione: +t.position || 0, attiva: t.is_active !== false, corrente: false }));
			const corrente = { chiave: 'corrente', nome: this.nomePrincipale || 'Questa tab', posizione: +this.item.position || 0, attiva: this.item.is_active !== false, corrente: true };
			// la tab sta dove sara' salvata: in fondo se nuova, al suo posto se in modifica;
			// sortBy e' stabile, quindi a parita' di posizione conta l'ordine salvato
			lista.splice(this.indiceCorrente === null ? lista.length : this.indiceCorrente, 0, corrente);
			return _.sortBy(lista, 'posizione');
		},
	},
};
</script>

<style scoped>
.at-summary {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 12px 20px;
	padding: 12px 16px;
	border-radius: 10px !important;
}
.at-avatar {
	flex: 0 0 52px;
	width: 52px;
	height: 52px;
	border-radius: 10px;
	border: 1px solid #e1e7ef;
	background: #f3f6fa;
	display: flex;
	align-items: center;
	justify-content: center;
}
.at-main {
	flex: 1 1 240px;
	min-width: 0;
}
.at-title {
	font-size: 17px;
	font-weight: 600;
	color: #1f2d3d;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.at-sub {
	font-size: 13px;
	color: #5f6b7a;
}
.at-chips {
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
	margin-top: 4px;
}
.additional-tab-form ::v-deep .section-card {
	height: auto;
}
.at-cols {
	margin-top: 0;
	margin-bottom: 0;
}
.at-cols > [class*='col'] {
	padding-top: 0;
	padding-bottom: 0;
}
.at-fields {
	margin: 0;
}
.at-fields > [class*='col'] {
	padding: 8px;
}
.at-hint {
	font-size: 12px;
	color: #5f6b7a;
}
.at-order {
	padding: 0 8px 8px;
}
.at-order-label {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin: 4px 0 6px;
}
.at-order-list {
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	overflow: hidden;
}
.at-order-item {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 6px 10px;
	font-size: 13px;
	background: #fff;
}
.at-order-item + .at-order-item {
	border-top: 1px solid #eef2f7;
}
.at-order-item--current {
	background: #e8f1fc;
	font-weight: 600;
	color: #1565c0;
}
.at-order-item--off:not(.at-order-item--current) {
	color: #9aa5b1;
}
.at-order-num {
	flex: 0 0 18px;
	font-size: 11px;
	color: #5f6b7a;
}
.at-order-name {
	flex: 1 1 auto;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.at-order-pos {
	font-size: 11px;
	color: #5f6b7a;
}
</style>
